// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2u9WyANk0v1N6186ifrZDB"};